import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Nav, Tab } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import { post } from "../../../helpers/api_helper";
import {
  capitalizeString,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import {
  POST_GetBranchDetailByID,
  POST_GetFormsList,
  POST_GetRolesDetailByID,
  POST_RolesInsert,
  POST_RolesUpdate,
} from "../../../helpers/url_helper";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const AddRoles = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [inwardApprovalRequired, setInwardApprovalRequired] = useState(false);
  const [testingApprovalRequired, setTestingApprovalRequired] = useState(false);
  const [reportPrintApprovalRequired, setReportPrintApprovalRequired] =
    useState(false);

  const validationSchema = Yup.object().shape({
    RoleName: Yup.string().trim().required("Role Name is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      RoleIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      RoleName: "",
      IsInwardApprover: false,
      IsOperationApprover: false,
      IsMachineCalibrationReminder: false,
      IsTPIVisitReminder: false,
      IsReportPrintingAdmin: false,
      IsInwardAdmin: false,
      //InwardApprovalRequired: false,
      //TestingApprovalRequired: false,
      ListOfForms: [],
      IsReportPrintApprover: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      RoleIDEncrypt,
      IsInwardApprover,
      IsOperationApprover,
      IsMachineCalibrationReminder,
      IsTPIVisitReminder,
      IsReportPrintingAdmin,
      //InwardApprovalRequired,
      //TestingApprovalRequired,
      ListOfForms,
      BranchIDEncrypt,
      IsInwardAdmin,
      IsReportPrintApprover,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let payload = {
      ...values,
      RoleName: values.RoleName.trim(),
      List: ListOfForms,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      RoleIDEncrypt: RoleIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    post(PrimaryIdParam ? POST_RolesUpdate : POST_RolesInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/roles");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getBranchDetailsByID();
    if (PrimaryIdParam) {
      getRolesDetailsByID();
    } else {
      getFormList();
    }
  }, []);

  useEffect(() => {
    getBranchDetailsByID();
  }, [BranchIDEncrypt]);

  const getBranchDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetBranchDetailByID, {
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // setInwardApprovalRequired(response?.InwardApprovalRequired);
          // setTestingApprovalRequired(response?.TestingApprovalRequired);
          setInwardApprovalRequired(
            AuthUser?.Permissions?.ApprovalWorkflow == 1
              ? response?.InwardApprovalRequired
              : false,
          );
          setTestingApprovalRequired(
            AuthUser?.Permissions?.ApprovalWorkflow == 1
              ? response?.TestingApprovalRequired
              : false,
          );
          setReportPrintApprovalRequired(
            AuthUser?.Permissions?.ApprovalWorkflow == 1
              ? response?.ReportPrintApprovalRequired
              : false,
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getFormList = () => {
    setIsLoading(true);
    post(POST_GetFormsList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ListOfForms: response?.List.map((item) => ({
              ...item,
              ChkIsReadAll: false,
              ChkIsEditAll: false,
              ChkIsAddAll: false,
              ChkIsActiveAll: false,
              ChkIsDeleteAll: false,
              ChkIsExportAll: false,
              ListOfFormsParent: item?.ListOfFormsParent.map(
                (itemSub, indexSub) => ({
                  FormIDEncrypt: itemSub?.FormIDEncrypt,
                  FormName: itemSub?.FormName,
                  FormNo: itemSub?.FormNo,
                  SubParentNoEncrypt: itemSub?.SubParentNoEncrypt,
                  ParentNoEncrypt: itemSub?.ParentNoEncrypt,
                  FormType: itemSub?.FormType,
                  IsRead: false,
                  IsAdd: false,
                  IsEdit: false,
                  IsActive: false,
                  IsDelete: false,
                  IsExport: false,
                  IsReadDisplay: itemSub?.IsReadDisplay,
                  IsAddDisplay: itemSub?.IsAddDisplay,
                  IsEditDisplay: itemSub?.IsEditDisplay,
                  IsActiveDisplay: itemSub?.IsActiveDisplay,
                  IsDeleteDisplay: itemSub?.IsDeleteDisplay,
                  IsExportDisplay: itemSub?.IsExportDisplay,
                  ListOfFormsSubParent: itemSub?.ListOfFormsSubParent.map(
                    (itemSubParent, indexSubParent) => ({
                      FormIDEncrypt: itemSubParent?.FormIDEncrypt,
                      FormName: itemSubParent?.FormName,
                      FormNo: itemSubParent?.FormNo,
                      SubParentNoEncrypt: itemSubParent?.SubParentNoEncrypt,
                      ParentNoEncrypt: itemSubParent?.ParentNoEncrypt,
                      FormType: itemSubParent?.FormType,
                      IsRead: false,
                      IsAdd: false,
                      IsEdit: false,
                      IsActive: false,
                      IsDelete: false,
                      IsExport: false,
                      IsReadDisplay: itemSubParent?.IsReadDisplay,
                      IsAddDisplay: itemSubParent?.IsAddDisplay,
                      IsEditDisplay: itemSubParent?.IsEditDisplay,
                      IsActiveDisplay: itemSubParent?.IsActiveDisplay,
                      IsDeleteDisplay: itemSubParent?.IsDeleteDisplay,
                      IsExportDisplay: itemSubParent?.IsExportDisplay,
                    }),
                  ),
                }),
              ),
            })),
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getRolesDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetRolesDetailByID, {
      RoleIDEncrypt: window.atob(PrimaryIdParam),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            IsMachineCalibrationReminder:
              AuthUser?.Permissions?.MachineMaintenance == 1
                ? response?.IsMachineCalibrationReminder
                : false,
            ListOfForms: response?.List.map((item) => ({
              ...item,
              ChkIsReadAll: false,
              ChkIsEditAll: false,
              ChkIsAddAll: false,
              ChkIsActiveAll: false,
              ChkIsDeleteAll: false,
              ChkIsExportAll: false,
              ListOfFormsParent: item?.ListOfFormsParent.map(
                (itemSub, indexSub) => ({
                  FormIDEncrypt: itemSub?.FormIDEncrypt,
                  FormName: itemSub?.FormName,
                  FormNo: itemSub?.FormNo,
                  SubParentNoEncrypt: itemSub?.SubParentNoEncrypt,
                  ParentNoEncrypt: itemSub?.ParentNoEncrypt,
                  FormType: itemSub?.FormType,
                  RoleDetailIDEncrypt: itemSub?.RoleDetailIDEncrypt,
                  RoleIDEncrypt: itemSub?.RoleIDEncrypt,
                  IsRead: itemSub?.IsRead,
                  IsAdd: itemSub?.IsAdd,
                  IsEdit: itemSub?.IsEdit,
                  IsActive: itemSub?.IsActive,
                  IsDelete: itemSub?.IsDelete,
                  IsExport: itemSub?.IsExport,
                  IsReadDisplay: itemSub?.IsReadDisplay,
                  IsAddDisplay: itemSub?.IsAddDisplay,
                  IsEditDisplay: itemSub?.IsEditDisplay,
                  IsActiveDisplay: itemSub?.IsActiveDisplay,
                  IsDeleteDisplay: itemSub?.IsDeleteDisplay,
                  IsExportDisplay: itemSub?.IsExportDisplay,
                  ListOfFormsSubParent: itemSub?.ListOfFormsSubParent.map(
                    (itemSubParent, indexSubParent) => ({
                      FormIDEncrypt: itemSubParent?.FormIDEncrypt,
                      FormName: itemSubParent?.FormName,
                      FormNo: itemSubParent?.FormNo,
                      SubParentNoEncrypt: itemSubParent?.SubParentNoEncrypt,
                      ParentNoEncrypt: itemSubParent?.ParentNoEncrypt,
                      FormType: itemSubParent?.FormType,
                      RoleDetailIDEncrypt: itemSubParent?.RoleDetailIDEncrypt,
                      RoleIDEncrypt: itemSubParent?.RoleIDEncrypt,
                      IsRead: itemSubParent?.IsRead,
                      IsAdd: itemSubParent?.IsAdd,
                      IsEdit: itemSubParent?.IsEdit,
                      IsActive: itemSubParent?.IsActive,
                      IsDelete: itemSubParent?.IsDelete,
                      IsExport: itemSubParent?.IsExport,
                      IsReadDisplay: itemSubParent?.IsReadDisplay,
                      IsAddDisplay: itemSubParent?.IsAddDisplay,
                      IsEditDisplay: itemSubParent?.IsEditDisplay,
                      IsActiveDisplay: itemSubParent?.IsActiveDisplay,
                      IsDeleteDisplay: itemSubParent?.IsDeleteDisplay,
                      IsExportDisplay: itemSubParent?.IsExportDisplay,
                    }),
                  ),
                }),
              ),
            })),
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const setDashboardRead = (
    addFlag,
    editFlag,
    index,
    indexSub,
    indexSubParent,
    listType,
  ) => {
    if (listType == 1) {
      if (addFlag == false && editFlag == false) {
        formik.setFieldValue(
          `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsRead`,
          false,
        );
      } else {
        formik.setFieldValue(
          `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsRead`,
          true,
        );
      }
    } else {
      if (addFlag == false && editFlag == false) {
        formik.setFieldValue(
          `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsRead`,
          false,
        );
      } else {
        formik.setFieldValue(
          `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsRead`,
          true,
        );
      }
    }
  };

  const applyAllRights = () => {
    let listForms = ListOfForms?.map((item) => ({
      ...item,
      ChkIsReadAll: true,
      ChkIsEditAll: true,
      ChkIsAddAll: true,
      ChkIsActiveAll: true,
      ChkIsDeleteAll: true,
      ChkIsExportAll: true,
      ListOfFormsParent: item?.ListOfFormsParent.map((itemSub) => ({
        ...itemSub,
        IsRead: itemSub?.IsReadDisplay ? true : itemSub?.IsRead,
        IsAdd: itemSub?.IsAddDisplay ? true : itemSub?.IsAdd,
        IsEdit: itemSub?.IsEditDisplay ? true : itemSub?.IsEdit,
        IsActive: itemSub?.IsActiveDisplay ? true : itemSub?.IsActive,
        IsDelete: itemSub?.IsDeleteDisplay ? true : itemSub?.IsDelete,
        IsExport: itemSub?.IsExportDisplay ? true : itemSub?.IsExport,
        ListOfFormsSubParent: itemSub?.ListOfFormsSubParent.map(
          (itemSubParent) => ({
            ...itemSubParent,
            IsRead: itemSubParent?.IsReadDisplay ? true : itemSubParent?.IsRead,
            IsAdd: itemSubParent?.IsAddDisplay ? true : itemSubParent?.IsAdd,
            IsEdit: itemSubParent?.IsEditDisplay ? true : itemSubParent?.IsEdit,
            IsActive: itemSubParent?.IsActiveDisplay
              ? true
              : itemSubParent?.IsActive,
            IsDelete: itemSubParent?.IsDeleteDisplay
              ? true
              : itemSubParent?.IsDelete,
            IsExport: itemSubParent?.IsExportDisplay
              ? true
              : itemSubParent?.IsExport,
          }),
        ),
      })),
    }));

    formik.setFieldValue("ListOfForms", listForms);

    if (inwardApprovalRequired) {
      formik.setFieldValue("IsInwardApprover", true);
    }

    if (testingApprovalRequired) {
      formik.setFieldValue("IsOperationApprover", true);
    }

    if (reportPrintApprovalRequired) {
      formik.setFieldValue("IsReportPrintApprover", true);
    }

    formik.setFieldValue("IsMachineCalibrationReminder", true);
    formik.setFieldValue("IsTPIVisitReminder", true);
    formik.setFieldValue("IsReportPrintingAdmin", true);
    formik.setFieldValue("IsInwardAdmin", true);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="active-projects style-1">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Roles
              </h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => {
                    applyAllRights();
                  }}
                >
                  <i className="fa-solid fa-square-check"></i> Apply All Rights
                </button>
              </div>
            </div>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      label={"Role Name"}
                      name="RoleName"
                      placeholder={"Enter Role Name"}
                      component={CustomInput}
                      maxLength={200}
                      required
                      autoFocus
                      onChange={(e) => {
                        formik.setFieldValue(
                          "RoleName",
                          capitalizeString(e?.target?.value),
                        );
                      }}
                    />
                  </Col>
                  <Col lg={9}>
                    <Row>
                      {inwardApprovalRequired &&
                      AuthUser?.LicenseTypeID != 5 ? (
                        <Col lg={3}>
                          {/* <label></label>
                          <div className="d-flex mb-2">
                            <label>Inward Approver &nbsp;</label>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                title={IsInwardApprover == true ? "Yes" : "No"}
                                checked={IsInwardApprover}
                                onChange={() => {
                                  formik.setFieldValue(
                                    "IsInwardApprover",
                                    !IsInwardApprover
                                  );
                                }}
                                style={{ cursor: "pointer" }}
                              ></input>
                            </div>
                          </div> */}
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="chkIsInwardApprover"
                            name="chkIsInwardApprover"
                            checked={IsInwardApprover}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "IsInwardApprover",
                                e?.target?.checked,
                              );
                            }}
                          />
                          &nbsp;
                          <label className="mt-1">
                            Inward Approver{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              placement="bottom"
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    Users having this right will be able to
                                    approve the Inwards after completing TC Test
                                    Allocation.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle ms-1"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                        </Col>
                      ) : (
                        ""
                      )}
                      {testingApprovalRequired &&
                      AuthUser?.LicenseTypeID != 5 ? (
                        <Col lg={3}>
                          {/* <label></label>
                          <div className="d-flex mb-2">
                            <label>Operation Approver &nbsp;</label>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                title={
                                  IsOperationApprover == true ? "Yes" : "No"
                                }
                                checked={IsOperationApprover}
                                onChange={() => {
                                  formik.setFieldValue(
                                    "IsOperationApprover",
                                    !IsOperationApprover
                                  );
                                }}
                                style={{ cursor: "pointer" }}
                              ></input>
                            </div>
                          </div> */}
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="chkIsOperationApprover"
                            name="chkIsOperationApprover"
                            checked={IsOperationApprover}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "IsOperationApprover",
                                e?.target?.checked,
                              );
                            }}
                          />
                          &nbsp;
                          <label className="mt-1">
                            Testing Approver{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="bottom"
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    Users having this right will be able to
                                    approve the Testing records for which user
                                    has filled the final result.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle ms-1"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                        </Col>
                      ) : (
                        ""
                      )}

                      {reportPrintApprovalRequired &&
                      AuthUser?.LicenseTypeID != 5 ? (
                        <Col lg={3}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="chkIsReportPrintApprover"
                            name="chkIsReportPrintApprover"
                            checked={IsReportPrintApprover}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "IsReportPrintApprover",
                                e?.target?.checked,
                              );
                            }}
                          />
                          &nbsp;
                          <label className="mt-1">
                            Report Print Approver{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="bottom"
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    Users having this right will be able to
                                    approve the Report Printing records for
                                    which user has draft print.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle ms-1"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                        </Col>
                      ) : (
                        ""
                      )}

                      {AuthUser?.Permissions?.MachineMaintenance == 1 &&
                      AuthUser?.Permissions?.Email == 1 ? (
                        <Col lg={3}>
                          {/* <label></label>
                          <div className="d-flex mb-2">
                            <label>Machine Calibration Reminder &nbsp;</label>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                title={
                                  IsMachineCalibrationReminder == true
                                    ? "Yes"
                                    : "No"
                                }
                                checked={IsMachineCalibrationReminder}
                                onChange={() => {
                                  formik.setFieldValue(
                                    "IsMachineCalibrationReminder",
                                    !IsMachineCalibrationReminder
                                  );
                                }}
                                style={{ cursor: "pointer" }}
                              ></input>
                            </div>
                          </div> */}
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="chkIsMachineCalibrationReminder"
                            name="chkIsMachineCalibrationReminder"
                            checked={IsMachineCalibrationReminder}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "IsMachineCalibrationReminder",
                                e?.target?.checked,
                              );
                            }}
                          />
                          &nbsp;
                          <label className="mt-1">
                            Machine Calibration Reminder{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="bottom"
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    Users having this right will also receive
                                    the Machine Calibration Expiry notification
                                    emails despite not having Machine
                                    calibration rights. This option will be
                                    useful for to receive notification for admin
                                    / management level users.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle ms-1"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                        </Col>
                      ) : (
                        ""
                      )}
                      {AuthUser?.Permissions?.Email == 1 ? (
                        <Col lg={3}>
                          {/* <label></label>
                        <div className="d-flex mb-2">
                          <label>TPI Visit Reminder &nbsp;</label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckChecked"
                              title={IsTPIVisitReminder == true ? "Yes" : "No"}
                              checked={IsTPIVisitReminder}
                              onChange={() => {
                                formik.setFieldValue(
                                  "IsTPIVisitReminder",
                                  !IsTPIVisitReminder
                                );
                              }}
                              style={{ cursor: "pointer" }}
                            ></input>
                          </div>
                        </div> */}
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="chkIsTPIVisitReminder"
                            name="chkIsTPIVisitReminder"
                            checked={IsTPIVisitReminder}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "IsTPIVisitReminder",
                                e?.target?.checked,
                              );
                            }}
                          />
                          &nbsp;
                          <label className="mt-1">
                            TPI Visit Reminder{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="bottom"
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    Users having this right will also receive
                                    the TPI Visit reminder despite not having
                                    rights of the testing. This option will be
                                    useful for receiving TPI visit reminder for
                                    department head level.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle ms-1"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                        </Col>
                      ) : (
                        ""
                      )}
                      {/* </Row>
                    <Row> */}
                      <Col lg={3}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="chkIsReportPrintingAdmin"
                          name="chkIsReportPrintingAdmin"
                          checked={IsReportPrintingAdmin}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "IsReportPrintingAdmin",
                              e?.target?.checked,
                            );
                          }}
                        />
                        &nbsp;
                        <label className="mt-1">
                          Report Printing Admin{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="bottom"
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Users having this right will able to edit
                                  opened report. For the users having this
                                  option off in the role will only view and
                                  print the report. Won't be able to modify
                                  anything on opened report screen.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle ms-1"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                      </Col>
                      <Col lg={3}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="chkIsInwardAdmin"
                          name="chkIsInwardAdmin"
                          checked={IsInwardAdmin}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "IsInwardAdmin",
                              e?.target?.checked,
                            );
                          }}
                        />
                        &nbsp;
                        <label className="mt-1">
                          Inward Admin{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="bottom"
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  User with this right will have a feature to
                                  modify Inward and Material information at any
                                  stage of the transaction. Specifically edit
                                  inward feature will be enable on Inward List /
                                  Control center. Other user without this right,
                                  will not see that edit inward option.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle ms-1"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr className="mt-0 mb-1"></hr>
                <div className="p-2 pt-0">
                  <div className="default-tab">
                    <Tab.Container defaultActiveKey={"dashboard"}>
                      <Nav as="ul" className="nav-tabs">
                        {ListOfForms?.length > 0
                          ? ListOfForms?.map((item, index) => (
                              <Nav.Item as="li" key={index}>
                                <Nav.Link
                                  eventKey={
                                    item?.FormNo == 1
                                      ? "dashboard"
                                      : item?.FormNo == 2
                                        ? "systemSetup"
                                        : item?.FormNo == 3
                                          ? "configuration"
                                          : item?.FormNo == 4
                                            ? "workProcess"
                                            : item?.FormNo == 5
                                              ? "utility"
                                              : item?.FormNo == 6
                                                ? "profile"
                                                : item?.FormNo == 50
                                                  ? "account"
                                                  : item?.FormNo == 89
                                                    ? "inventory"
                                                    : ""
                                  }
                                >
                                  {item?.FormNo == 1 ? (
                                    <i className="la la-home me-2"></i>
                                  ) : item?.FormNo == 2 ? (
                                    <i className="la la-user-cog me-2"></i>
                                  ) : item?.FormNo == 3 ? (
                                    <i className="la la-cogs me-2"></i>
                                  ) : item?.FormNo == 4 ? (
                                    <i className="la la-comment me-2" />
                                  ) : item?.FormNo == 5 ? (
                                    <i className="la la-indent me-2"></i>
                                  ) : item?.FormNo == 6 ? (
                                    <i className="la la-user me-2"></i>
                                  ) : item?.FormNo == 50 ? (
                                    <i className="la la-bank me-2"></i>
                                  ) : item?.FormNo == 89 ? (
                                    <i className="la la-box-open me-2"></i>
                                  ) : (
                                    ""
                                  )}
                                  {item?.FormName}
                                </Nav.Link>
                              </Nav.Item>
                            ))
                          : ""}
                      </Nav>
                      <Tab.Content className="pt-2">
                        {ListOfForms?.length > 0
                          ? ListOfForms?.map((item, index) => (
                              <Tab.Pane
                                eventKey={
                                  item?.FormNo == 1
                                    ? "dashboard"
                                    : item?.FormNo == 2
                                      ? "systemSetup"
                                      : item?.FormNo == 3
                                        ? "configuration"
                                        : item?.FormNo == 4
                                          ? "workProcess"
                                          : item?.FormNo == 5
                                            ? "utility"
                                            : item?.FormNo == 6
                                              ? "profile"
                                              : item?.FormNo == 50
                                                ? "account"
                                                : item?.FormNo == 89
                                                  ? "inventory"
                                                  : ""
                                }
                                key={index}
                              >
                                <div className="table-responsive active-projects style-1 shorting">
                                  <div
                                    id="dashboard-tbl_wrapper"
                                    className="dataTables_wrapper table-responsive no-footer"
                                  >
                                    <table
                                      id="dashboard-tbl"
                                      className="table dataTable no-footer mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th width="5%">Sr. No</th>
                                          {item?.ListOfFormsParent?.filter(
                                            (x) =>
                                              x.ListOfFormsSubParent?.length >
                                              0,
                                          )?.length > 0 && (
                                            <th width="15%">Parent</th>
                                          )}
                                          <th width="20%">Form Name</th>
                                          <th width="10%">
                                            <input
                                              type="checkbox"
                                              className="form-check-input me-1"
                                              id={`ChkIsReadAll${index}`}
                                              name={`ChkIsReadAll${index}`}
                                              checked={
                                                item?.ListOfFormsParent
                                                  ?.length > 0 &&
                                                item?.ListOfFormsParent?.every(
                                                  (parent) =>
                                                    !parent.IsReadDisplay ||
                                                    parent.IsRead ||
                                                    parent.ListOfFormsSubParent?.some(
                                                      (sub) => sub.IsRead,
                                                    ),
                                                ) &&
                                                item?.ListOfFormsParent?.every(
                                                  (parent) =>
                                                    parent.ListOfFormsSubParent
                                                      ?.length > 0
                                                      ? parent.ListOfFormsSubParent.every(
                                                          (subParent) =>
                                                            !subParent.IsReadDisplay ||
                                                            subParent.IsRead,
                                                        )
                                                      : true,
                                                )
                                              }
                                              onChange={(e) => {
                                                const isChecked =
                                                  e.target.checked;
                                                // Update all checkboxes in the selected form
                                                const updatedList =
                                                  formik.values.ListOfForms.map(
                                                    (form, i) => {
                                                      if (i === index) {
                                                        return {
                                                          ...form,
                                                          ListOfFormsParent:
                                                            form.ListOfFormsParent.map(
                                                              (parent) => ({
                                                                ...parent,
                                                                IsRead:
                                                                  isChecked, // Update Parent Checkbox
                                                                ListOfFormsSubParent:
                                                                  parent.ListOfFormsSubParent.map(
                                                                    (
                                                                      subParent,
                                                                    ) => ({
                                                                      ...subParent,
                                                                      IsRead:
                                                                        isChecked, // Update Sub-Parent Checkbox
                                                                    }),
                                                                  ),
                                                              }),
                                                            ),
                                                        };
                                                      }
                                                      return form;
                                                    },
                                                  );

                                                formik.setFieldValue(
                                                  "ListOfForms",
                                                  updatedList,
                                                );
                                                formik.setFieldValue(
                                                  `ListOfForms[${index}].ChkIsReadAll`,
                                                  isChecked,
                                                );
                                              }}
                                            />{" "}
                                            Read
                                          </th>
                                          <th width="10%">
                                            {item?.ListOfFormsParent?.some(
                                              (parent) =>
                                                parent.IsAddDisplay ||
                                                parent.ListOfFormsSubParent?.some(
                                                  (sub) => sub.IsAddDisplay,
                                                ),
                                            ) && (
                                              <input
                                                type="checkbox"
                                                className="form-check-input me-1"
                                                id={`ChkIsAddAll${index}`}
                                                name={`ChkIsAddAll${index}`}
                                                checked={
                                                  item?.ListOfFormsParent
                                                    ?.length > 0 &&
                                                  item?.ListOfFormsParent.some(
                                                    (parent) =>
                                                      parent.IsAdd ||
                                                      parent.ListOfFormsSubParent?.some(
                                                        (sub) => sub.IsAdd,
                                                      ), // At least one sub-checkbox is checked
                                                  ) &&
                                                  item?.ListOfFormsParent.every(
                                                    (parent) =>
                                                      (!parent.IsAddDisplay ||
                                                        parent.IsAdd) && // Parent checkbox is either hidden or checked
                                                      (parent
                                                        .ListOfFormsSubParent
                                                        ?.length > 0
                                                        ? parent.ListOfFormsSubParent.every(
                                                            (subParent) =>
                                                              !subParent.IsAddDisplay ||
                                                              subParent.IsAdd,
                                                          ) // All sub-checkboxes must be checked if they exist
                                                        : true),
                                                  )
                                                }
                                                onChange={(e) => {
                                                  const isChecked =
                                                    e.target.checked;

                                                  // Update all checkboxes in the selected form
                                                  const updatedList =
                                                    formik.values.ListOfForms.map(
                                                      (form, i) => {
                                                        if (i === index) {
                                                          return {
                                                            ...form,
                                                            ListOfFormsParent:
                                                              form.ListOfFormsParent.map(
                                                                (parent) => ({
                                                                  ...parent,
                                                                  IsAdd:
                                                                    isChecked, // Update Parent Checkbox
                                                                  IsRead:
                                                                    isChecked,

                                                                  ListOfFormsSubParent:
                                                                    parent.ListOfFormsSubParent.map(
                                                                      (
                                                                        subParent,
                                                                      ) => ({
                                                                        ...subParent,
                                                                        IsAdd:
                                                                          isChecked, // Update Sub-Parent Checkbox
                                                                        IsRead:
                                                                          isChecked,
                                                                      }),
                                                                    ),
                                                                }),
                                                              ),
                                                          };
                                                        }
                                                        return form;
                                                      },
                                                    );

                                                  formik.setFieldValue(
                                                    "ListOfForms",
                                                    updatedList,
                                                  );
                                                  formik.setFieldValue(
                                                    `ListOfForms[${index}].ChkIsAddAll`,
                                                    isChecked,
                                                  );
                                                }}
                                              />
                                            )}{" "}
                                            Add
                                          </th>
                                          <th width="10%">
                                            {item?.ListOfFormsParent?.some(
                                              (parent) =>
                                                parent.IsEditDisplay ||
                                                parent.ListOfFormsSubParent?.some(
                                                  (sub) => sub.IsEditDisplay,
                                                ),
                                            ) && (
                                              <input
                                                type="checkbox"
                                                id={`ChkIsEditAll${index}`}
                                                name={`ChkIsEditAll${index}`}
                                                className="form-check-input"
                                                checked={
                                                  item?.ListOfFormsParent
                                                    ?.length > 0 &&
                                                  item?.ListOfFormsParent.some(
                                                    (parent) =>
                                                      parent.IsEdit ||
                                                      parent.ListOfFormsSubParent?.some(
                                                        (sub) => sub.IsEdit,
                                                      ), // At least one sub-checkbox is checked
                                                  ) &&
                                                  item?.ListOfFormsParent.every(
                                                    (parent) =>
                                                      (!parent.IsEditDisplay ||
                                                        parent.IsEdit) && // Parent checkbox is either hidden or checked
                                                      (parent
                                                        .ListOfFormsSubParent
                                                        ?.length > 0
                                                        ? parent.ListOfFormsSubParent.every(
                                                            (subParent) =>
                                                              !subParent.IsEditDisplay ||
                                                              subParent.IsEdit,
                                                          ) // All sub-checkboxes must be checked if they exist
                                                        : true),
                                                  )
                                                }
                                                onChange={(e) => {
                                                  const isChecked =
                                                    e.target.checked;

                                                  // Update all checkboxes in the selected form
                                                  const updatedList =
                                                    formik.values.ListOfForms.map(
                                                      (form, i) => {
                                                        if (i === index) {
                                                          return {
                                                            ...form,
                                                            ListOfFormsParent:
                                                              form.ListOfFormsParent.map(
                                                                (parent) => ({
                                                                  ...parent,
                                                                  IsEdit:
                                                                    isChecked, // Update Parent Checkbox
                                                                  IsRead:
                                                                    isChecked,
                                                                  ListOfFormsSubParent:
                                                                    parent.ListOfFormsSubParent.map(
                                                                      (
                                                                        subParent,
                                                                      ) => ({
                                                                        ...subParent,
                                                                        IsEdit:
                                                                          isChecked, // Update Sub-Parent Checkbox
                                                                        IsRead:
                                                                          isChecked,
                                                                      }),
                                                                    ),
                                                                }),
                                                              ),
                                                          };
                                                        }
                                                        return form;
                                                      },
                                                    );

                                                  formik.setFieldValue(
                                                    "ListOfForms",
                                                    updatedList,
                                                  );
                                                  formik.setFieldValue(
                                                    `ListOfForms[${index}].ChkIsEditAll`,
                                                    isChecked,
                                                  );
                                                }}
                                              />
                                            )}{" "}
                                            Edit
                                          </th>
                                          <th width="10%">
                                            {item?.ListOfFormsParent?.some(
                                              (parent) =>
                                                parent.IsActiveDisplay ||
                                                parent.ListOfFormsSubParent?.some(
                                                  (sub) => sub.IsActiveDisplay,
                                                ),
                                            ) && (
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`ChkIsActiveAll${index}`}
                                                name={`ChkIsActiveAll${index}`}
                                                checked={
                                                  item?.ListOfFormsParent
                                                    ?.length > 0 &&
                                                  item?.ListOfFormsParent.some(
                                                    (parent) =>
                                                      parent.IsActive ||
                                                      parent.ListOfFormsSubParent?.some(
                                                        (sub) => sub.IsActive,
                                                      ), // At least one sub-checkbox is checked
                                                  ) &&
                                                  item?.ListOfFormsParent.every(
                                                    (parent) =>
                                                      (!parent.IsActiveDisplay ||
                                                        parent.IsActive) && // Parent checkbox is either hidden or checked
                                                      (parent
                                                        .ListOfFormsSubParent
                                                        ?.length > 0
                                                        ? parent.ListOfFormsSubParent.every(
                                                            (subParent) =>
                                                              !subParent.IsActiveDisplay ||
                                                              subParent.IsActive,
                                                          ) // All sub-checkboxes must be checked if they exist
                                                        : true),
                                                  )
                                                }
                                                onChange={(e) => {
                                                  const isChecked =
                                                    e.target.checked;

                                                  // Update all checkboxes in the selected form
                                                  const updatedList =
                                                    formik.values.ListOfForms.map(
                                                      (form, i) => {
                                                        if (i === index) {
                                                          return {
                                                            ...form,
                                                            ListOfFormsParent:
                                                              form.ListOfFormsParent.map(
                                                                (parent) => ({
                                                                  ...parent,
                                                                  IsActive:
                                                                    isChecked, // Update Parent Checkbox
                                                                  ListOfFormsSubParent:
                                                                    parent.ListOfFormsSubParent.map(
                                                                      (
                                                                        subParent,
                                                                      ) => ({
                                                                        ...subParent,
                                                                        IsActive:
                                                                          isChecked, // Update Sub-Parent Checkbox
                                                                      }),
                                                                    ),
                                                                }),
                                                              ),
                                                          };
                                                        }
                                                        return form;
                                                      },
                                                    );

                                                  formik.setFieldValue(
                                                    "ListOfForms",
                                                    updatedList,
                                                  );
                                                  formik.setFieldValue(
                                                    `ListOfForms[${index}].ChkIsEditAll`,
                                                    isChecked,
                                                  );
                                                }}
                                              />
                                            )}{" "}
                                            Is Active
                                          </th>
                                          <th width="10%">
                                            {item?.ListOfFormsParent?.some(
                                              (parent) =>
                                                parent.IsDeleteDisplay ||
                                                parent.ListOfFormsSubParent?.some(
                                                  (sub) => sub.IsDeleteDisplay,
                                                ),
                                            ) && (
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`ChkIsDeleteAll${index}`}
                                                name={`ChkIsDeleteAll${index}`}
                                                checked={
                                                  item?.ListOfFormsParent
                                                    ?.length > 0 &&
                                                  item?.ListOfFormsParent.some(
                                                    (parent) =>
                                                      parent.IsDelete ||
                                                      parent.ListOfFormsSubParent?.some(
                                                        (sub) => sub.IsDelete,
                                                      ), // At least one sub-checkbox is checked
                                                  ) &&
                                                  item?.ListOfFormsParent.every(
                                                    (parent) =>
                                                      (!parent.IsDeleteDisplay ||
                                                        parent.IsDelete) && // Parent checkbox is either hidden or checked
                                                      (parent
                                                        .ListOfFormsSubParent
                                                        ?.length > 0
                                                        ? parent.ListOfFormsSubParent.every(
                                                            (subParent) =>
                                                              !subParent.IsDeleteDisplay ||
                                                              subParent.IsDelete,
                                                          ) // All sub-checkboxes must be checked if they exist
                                                        : true),
                                                  )
                                                }
                                                onChange={(e) => {
                                                  const isChecked =
                                                    e.target.checked;

                                                  // Update all checkboxes in the selected form
                                                  const updatedList =
                                                    formik.values.ListOfForms.map(
                                                      (form, i) => {
                                                        if (i === index) {
                                                          return {
                                                            ...form,
                                                            ListOfFormsParent:
                                                              form.ListOfFormsParent.map(
                                                                (parent) => ({
                                                                  ...parent,
                                                                  IsDelete:
                                                                    isChecked, // Update Parent Checkbox
                                                                  ListOfFormsSubParent:
                                                                    parent.ListOfFormsSubParent.map(
                                                                      (
                                                                        subParent,
                                                                      ) => ({
                                                                        ...subParent,
                                                                        IsDelete:
                                                                          isChecked, // Update Sub-Parent Checkbox
                                                                      }),
                                                                    ),
                                                                }),
                                                              ),
                                                          };
                                                        }
                                                        return form;
                                                      },
                                                    );

                                                  formik.setFieldValue(
                                                    "ListOfForms",
                                                    updatedList,
                                                  );
                                                  formik.setFieldValue(
                                                    `ListOfForms[${index}].ChkIsDeleteAll`,
                                                    isChecked,
                                                  );
                                                }}
                                              />
                                            )}{" "}
                                            Delete
                                          </th>
                                          <th
                                            width="10%"
                                            style={{ textAlign: "left" }}
                                          >
                                            {item?.ListOfFormsParent?.some(
                                              (parent) =>
                                                parent.IsExportDisplay ||
                                                parent.ListOfFormsSubParent?.some(
                                                  (sub) => sub.IsExportDisplay,
                                                ),
                                            ) && (
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`ChkIsExportAll${index}`}
                                                name={`ChkIsExportAll${index}`}
                                                checked={
                                                  item?.ListOfFormsParent
                                                    ?.length > 0 &&
                                                  item?.ListOfFormsParent.some(
                                                    (parent) =>
                                                      parent.IsExport ||
                                                      parent.ListOfFormsSubParent?.some(
                                                        (sub) => sub.IsExport,
                                                      ), // At least one sub-checkbox is checked
                                                  ) &&
                                                  item?.ListOfFormsParent.every(
                                                    (parent) =>
                                                      (!parent.IsExportDisplay ||
                                                        parent.IsExport) && // Parent checkbox is either hidden or checked
                                                      (parent
                                                        .ListOfFormsSubParent
                                                        ?.length > 0
                                                        ? parent.ListOfFormsSubParent.every(
                                                            (subParent) =>
                                                              !subParent.IsExportDisplay ||
                                                              subParent.IsExport,
                                                          ) // All sub-checkboxes must be checked if they exist
                                                        : true),
                                                  )
                                                }
                                                onChange={(e) => {
                                                  const isChecked =
                                                    e.target.checked;

                                                  // Update all checkboxes in the selected form
                                                  const updatedList =
                                                    formik.values.ListOfForms.map(
                                                      (form, i) => {
                                                        if (i === index) {
                                                          return {
                                                            ...form,
                                                            ListOfFormsParent:
                                                              form.ListOfFormsParent.map(
                                                                (parent) => ({
                                                                  ...parent,
                                                                  IsExport:
                                                                    isChecked, // Update Parent Checkbox
                                                                  ListOfFormsSubParent:
                                                                    parent.ListOfFormsSubParent.map(
                                                                      (
                                                                        subParent,
                                                                      ) => ({
                                                                        ...subParent,
                                                                        IsExport:
                                                                          isChecked, // Update Sub-Parent Checkbox
                                                                      }),
                                                                    ),
                                                                }),
                                                              ),
                                                          };
                                                        }
                                                        return form;
                                                      },
                                                    );

                                                  formik.setFieldValue(
                                                    "ListOfForms",
                                                    updatedList,
                                                  );
                                                  formik.setFieldValue(
                                                    `ListOfForms[${index}].ChkIsExportAll`,
                                                    isChecked,
                                                  );
                                                }}
                                              />
                                            )}{" "}
                                            Export
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item?.ListOfFormsParent?.length > 0 ? (
                                          item?.ListOfFormsParent?.map(
                                            (itemSub, indexSub) => (
                                              <>
                                                <tr>
                                                  <td>{indexSub + 1}</td>
                                                  {itemSub?.FormType != 2 ? (
                                                    <>
                                                      {item?.ListOfFormsParent?.filter(
                                                        (x) =>
                                                          x.ListOfFormsSubParent
                                                            ?.length > 0,
                                                      )?.length > 0 && (
                                                        <td>
                                                          {itemSub.FormName}
                                                        </td>
                                                      )}

                                                      <td>
                                                        {itemSub.FormName}
                                                        <input
                                                          type="checkbox"
                                                          className="form-check-input me-5"
                                                          style={{
                                                            float: "right",
                                                          }}
                                                          checked={
                                                            (itemSub?.IsReadDisplay
                                                              ? itemSub.IsRead
                                                              : true) && // Only check Read if displayed
                                                            (itemSub?.IsAddDisplay
                                                              ? itemSub.IsAdd
                                                              : true) &&
                                                            (itemSub?.IsEditDisplay
                                                              ? itemSub.IsEdit
                                                              : true) &&
                                                            (itemSub?.IsActiveDisplay
                                                              ? itemSub.IsActive
                                                              : true) &&
                                                            (itemSub?.IsDeleteDisplay
                                                              ? itemSub.IsDelete
                                                              : true) &&
                                                            (itemSub?.IsExportDisplay
                                                              ? itemSub.IsExport
                                                              : true)
                                                          }
                                                          onChange={(e) => {
                                                            const isChecked =
                                                              e.target.checked;
                                                            // Update only displayed checkboxes
                                                            formik.setFieldValue(
                                                              `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsRead`,
                                                              isChecked,
                                                            );
                                                            formik.setFieldValue(
                                                              `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsAdd`,
                                                              isChecked,
                                                            );
                                                            formik.setFieldValue(
                                                              `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsEdit`,
                                                              isChecked,
                                                            );
                                                            formik.setFieldValue(
                                                              `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsActive`,
                                                              isChecked,
                                                            );
                                                            formik.setFieldValue(
                                                              `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsDelete`,
                                                              isChecked,
                                                            );
                                                            formik.setFieldValue(
                                                              `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsExport`,
                                                              isChecked,
                                                            );
                                                          }}
                                                        />
                                                      </td>
                                                      <td>
                                                        {itemSub?.IsReadDisplay ? (
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`chkIsRead${indexSub}`}
                                                            name={`chkIsRead${indexSub}`}
                                                            checked={
                                                              itemSub?.IsRead
                                                            }
                                                            onChange={(e) => {
                                                              formik.setFieldValue(
                                                                `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsRead`,
                                                                e?.target
                                                                  ?.checked,
                                                              );
                                                            }}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                      <td>
                                                        {itemSub?.IsAddDisplay ? (
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`chkIsAdd${indexSub}`}
                                                            name={`chkIsAdd${indexSub}`}
                                                            checked={
                                                              itemSub?.IsAdd
                                                            }
                                                            onChange={(e) => {
                                                              formik.setFieldValue(
                                                                `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsAdd`,
                                                                e?.target
                                                                  ?.checked,
                                                              );

                                                              setDashboardRead(
                                                                e?.target
                                                                  ?.checked,
                                                                ListOfForms[
                                                                  index
                                                                ]
                                                                  .ListOfFormsParent[
                                                                  indexSub
                                                                ]?.IsEdit,
                                                                index,
                                                                indexSub,
                                                                0,
                                                                1,
                                                              );

                                                              // setDashboardRead(
                                                              //   e?.target?.checked,
                                                              //   ListOfForms[index]?.ListOfDashboard[
                                                              //     indexSub
                                                              //   ]?.IsEdit,
                                                              //   index,
                                                              //   indexSub
                                                              // );
                                                            }}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                      <td>
                                                        {itemSub?.IsEditDisplay ? (
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`chkIsEdit${indexSub}`}
                                                            name={`chkIsEdit${indexSub}`}
                                                            checked={
                                                              itemSub?.IsEdit
                                                            }
                                                            onChange={(e) => {
                                                              formik.setFieldValue(
                                                                `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsEdit`,
                                                                e?.target
                                                                  ?.checked,
                                                              );

                                                              setDashboardRead(
                                                                ListOfForms[
                                                                  index
                                                                ]
                                                                  .ListOfFormsParent[
                                                                  indexSub
                                                                ]?.IsAdd,
                                                                e?.target
                                                                  ?.checked,
                                                                index,
                                                                indexSub,
                                                                0,
                                                                1,
                                                              );

                                                              // setDashboardRead(
                                                              //   ListOfForms[index]
                                                              //     ?.ListOfDashboard[
                                                              //     indexSub
                                                              //   ]?.IsAdd,
                                                              //   e?.target?.checked,
                                                              //   index,
                                                              //   indexSub
                                                              // );
                                                            }}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                      <td>
                                                        {itemSub?.IsActiveDisplay ? (
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`chkIsActive${indexSub}`}
                                                            name={`chkIsActive${indexSub}`}
                                                            checked={
                                                              itemSub?.IsActive
                                                            }
                                                            onChange={(e) => {
                                                              formik.setFieldValue(
                                                                `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsActive`,
                                                                e?.target
                                                                  ?.checked,
                                                              );
                                                            }}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                      <td>
                                                        {itemSub?.IsDeleteDisplay ? (
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`chkIsDelete${indexSub}`}
                                                            name={`chkIsDelete${indexSub}`}
                                                            checked={
                                                              itemSub?.IsDelete
                                                            }
                                                            onChange={(e) => {
                                                              formik.setFieldValue(
                                                                `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsDelete`,
                                                                e?.target
                                                                  ?.checked,
                                                              );
                                                            }}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {itemSub?.IsExportDisplay ? (
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`chkIsExport${indexSub}`}
                                                            name={`chkIsExport${indexSub}`}
                                                            checked={
                                                              itemSub?.IsExport
                                                            }
                                                            onChange={(e) => {
                                                              formik.setFieldValue(
                                                                `ListOfForms[${index}].ListOfFormsParent[${indexSub}].IsExport`,
                                                                e?.target
                                                                  ?.checked,
                                                              );
                                                            }}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <td>
                                                        {itemSub.FormName}
                                                      </td>
                                                      <td colSpan={8}></td>
                                                    </>
                                                  )}
                                                </tr>

                                                {itemSub?.ListOfFormsSubParent
                                                  ?.length > 0
                                                  ? itemSub?.ListOfFormsSubParent?.map(
                                                      (
                                                        itemSubParent,
                                                        indexSubParent,
                                                      ) => (
                                                        <>
                                                          <tr>
                                                            <td></td>
                                                            {item?.ListOfFormsParent?.filter(
                                                              (x) =>
                                                                x
                                                                  .ListOfFormsSubParent
                                                                  ?.length > 0,
                                                            )?.length > 0 && (
                                                              <td></td>
                                                            )}
                                                            <td>
                                                              {
                                                                itemSubParent.FormName
                                                              }
                                                              <input
                                                                type="checkbox"
                                                                className="form-check-input me-5"
                                                                style={{
                                                                  float:
                                                                    "right",
                                                                }}
                                                                checked={
                                                                  (itemSubParent?.IsReadDisplay
                                                                    ? itemSubParent.IsRead
                                                                    : true) && // Only check Read if displayed
                                                                  (itemSubParent?.IsAddDisplay
                                                                    ? itemSubParent.IsAdd
                                                                    : true) &&
                                                                  (itemSubParent?.IsEditDisplay
                                                                    ? itemSubParent.IsEdit
                                                                    : true) &&
                                                                  (itemSubParent?.IsActiveDisplay
                                                                    ? itemSubParent.IsActive
                                                                    : true) &&
                                                                  (itemSubParent?.IsDeleteDisplay
                                                                    ? itemSubParent.IsDelete
                                                                    : true) &&
                                                                  (itemSubParent?.IsExportDisplay
                                                                    ? itemSubParent.IsExport
                                                                    : true)
                                                                }
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  const isChecked =
                                                                    e.target
                                                                      .checked;
                                                                  // When "Form Name" checkbox is checked/unchecked, update all checkboxes in the row
                                                                  formik.setFieldValue(
                                                                    `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsRead`,
                                                                    isChecked,
                                                                  );
                                                                  formik.setFieldValue(
                                                                    `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsAdd`,
                                                                    isChecked,
                                                                  );
                                                                  formik.setFieldValue(
                                                                    `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsEdit`,
                                                                    isChecked,
                                                                  );
                                                                  formik.setFieldValue(
                                                                    `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsActive`,
                                                                    isChecked,
                                                                  );
                                                                  formik.setFieldValue(
                                                                    `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsDelete`,
                                                                    isChecked,
                                                                  );
                                                                  formik.setFieldValue(
                                                                    `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsExport`,
                                                                    isChecked,
                                                                  );
                                                                }}
                                                              />
                                                            </td>
                                                            <td>
                                                              {itemSubParent?.IsReadDisplay ? (
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input"
                                                                  id={`chkIsRead${indexSubParent}`}
                                                                  name={`chkIsRead${indexSubParent}`}
                                                                  checked={
                                                                    itemSubParent?.IsRead
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) => {
                                                                    formik.setFieldValue(
                                                                      `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsRead`,
                                                                      e?.target
                                                                        ?.checked,
                                                                    );
                                                                  }}
                                                                />
                                                              ) : (
                                                                ""
                                                              )}
                                                            </td>
                                                            <td>
                                                              {itemSubParent?.IsAddDisplay ? (
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input"
                                                                  id={`chkIsAdd${indexSubParent}`}
                                                                  name={`chkIsAdd${indexSubParent}`}
                                                                  checked={
                                                                    itemSubParent?.IsAdd
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) => {
                                                                    formik.setFieldValue(
                                                                      `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsAdd`,
                                                                      e?.target
                                                                        ?.checked,
                                                                    );

                                                                    setDashboardRead(
                                                                      e?.target
                                                                        ?.checked,
                                                                      ListOfForms[
                                                                        index
                                                                      ]
                                                                        .ListOfFormsParent[
                                                                        indexSub
                                                                      ]
                                                                        .ListOfFormsSubParent[
                                                                        indexSubParent
                                                                      ]?.IsEdit,
                                                                      index,
                                                                      indexSub,
                                                                      indexSubParent,
                                                                      2,
                                                                    );

                                                                    // setDashboardRead(
                                                                    //   e?.target?.checked,
                                                                    //   ListOfForms[index]?.ListOfDashboard[
                                                                    //     indexSub
                                                                    //   ]?.IsEdit,
                                                                    //   index,
                                                                    //   indexSub
                                                                    // );
                                                                  }}
                                                                />
                                                              ) : (
                                                                ""
                                                              )}
                                                            </td>
                                                            <td>
                                                              {itemSubParent?.IsEditDisplay ? (
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input"
                                                                  id={`chkIsEdit${indexSubParent}`}
                                                                  name={`chkIsEdit${indexSubParent}`}
                                                                  checked={
                                                                    itemSubParent?.IsEdit
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) => {
                                                                    formik.setFieldValue(
                                                                      `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsEdit`,
                                                                      e?.target
                                                                        ?.checked,
                                                                    );

                                                                    setDashboardRead(
                                                                      ListOfForms[
                                                                        index
                                                                      ]
                                                                        .ListOfFormsParent[
                                                                        indexSub
                                                                      ]
                                                                        .ListOfFormsSubParent[
                                                                        indexSubParent
                                                                      ]?.IsAdd,
                                                                      e?.target
                                                                        ?.checked,
                                                                      index,
                                                                      indexSub,
                                                                      indexSubParent,
                                                                      2,
                                                                    );
                                                                  }}
                                                                />
                                                              ) : (
                                                                ""
                                                              )}
                                                            </td>
                                                            <td>
                                                              {itemSubParent?.IsActiveDisplay ? (
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input"
                                                                  id={`chkIsActive${indexSubParent}`}
                                                                  name={`chkIsActive${indexSubParent}`}
                                                                  checked={
                                                                    itemSubParent?.IsActive
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) => {
                                                                    formik.setFieldValue(
                                                                      `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsActive`,
                                                                      e?.target
                                                                        ?.checked,
                                                                    );
                                                                  }}
                                                                />
                                                              ) : (
                                                                ""
                                                              )}
                                                            </td>
                                                            <td>
                                                              {itemSubParent?.IsDeleteDisplay ? (
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input"
                                                                  id={`chkIsDelete${indexSubParent}`}
                                                                  name={`chkIsDelete${indexSubParent}`}
                                                                  checked={
                                                                    itemSubParent?.IsDelete
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) => {
                                                                    formik.setFieldValue(
                                                                      `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsDelete`,
                                                                      e?.target
                                                                        ?.checked,
                                                                    );
                                                                  }}
                                                                />
                                                              ) : (
                                                                ""
                                                              )}
                                                            </td>
                                                            <td
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              {itemSubParent?.IsExportDisplay ? (
                                                                <input
                                                                  type="checkbox"
                                                                  className="form-check-input"
                                                                  id={`chkIsExport${indexSubParent}`}
                                                                  name={`chkIsExport${indexSubParent}`}
                                                                  checked={
                                                                    itemSubParent?.IsExport
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) => {
                                                                    formik.setFieldValue(
                                                                      `ListOfForms[${index}].ListOfFormsParent[${indexSub}].ListOfFormsSubParent[${indexSubParent}].IsExport`,
                                                                      e?.target
                                                                        ?.checked,
                                                                    );
                                                                  }}
                                                                />
                                                              ) : (
                                                                ""
                                                              )}
                                                            </td>
                                                          </tr>
                                                        </>
                                                      ),
                                                    )
                                                  : ""}
                                              </>
                                            ),
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={8}
                                              style={{
                                                textAlign: "left",
                                              }}
                                            >
                                              <div>{"No Record Found..."}</div>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </Tab.Pane>
                            ))
                          : ""}
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </div>

                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AddRoles;
